import { isFacebookBrowser } from '@patrianna/shared-utils/helpers'

import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector, sweepstakeEnabledSelector } from 'store/modules/appConfig/selectors'
import { isLoggedInSelector } from 'store/modules/user/selectors'

import LogInToAccess from '../LogInToAccess'

import ActivateSCmode from './ActivateSCmode'
import ActiveSCLoader from './Loader'

function ActiveSCPage() {
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const isSCenabled = useAppSelector(sweepstakeEnabledSelector)
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const fbBrowser = isFacebookBrowser()

  if (!isLoggedIn && appInitialized && !fbBrowser) {
    return <LogInToAccess />
  }

  if (appInitialized) {
    return <ActivateSCmode isLoggedIn={isLoggedIn} isSCenabled={isSCenabled} fbBrowser={fbBrowser} />
  }

  return <ActiveSCLoader />
}

export default ActiveSCPage
